import { AlphaConfigurationControlType } from '../../common/types';

export default class TreeFeatureFlagModel {
    constructor(
        readonly key: string,
        readonly keyPart: string,
        readonly controlType: AlphaConfigurationControlType
    ) {}
}
